import {
  ROUTE_ANALYTICS,
  ROUTE_ANALYTICS_TREATMENT,
} from '../../../Routes/routes';

const breadcrumbs = (t) => [{
  title: t('Views.analyticsTitle'),
  route: `/${ROUTE_ANALYTICS}`,
}, {
  title: t('Analytics.treatmentTitle'),
  route: `/${ROUTE_ANALYTICS_TREATMENT}`,
}];

export default breadcrumbs;
